import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  profileStepperKey: 0,
  innerStepperKey: 0,
  loading: false,
  stepperStatus: {},
  totalQuestions: 0,
  answeredQuestions: 0,
  infoContent: "",
  showMenu: true,
  menuTitle: "Settings",
  showSubMenu: true
};

const commonSlice = createSlice({
  name: "common",
  initialState,
  reducers: {
    setProfileStepper(state, action) {
      state.profileStepperKey = action.payload;
    },
    setInnerStepper(state, action) {
      state.innerStepperKey = action.payload;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setStepperStatus(state, action) {
      state.stepperStatus = action.payload;
    },
    setTotalQuestions(state, action) {
      state.totalQuestions = action.payload;
    },
    setAnsweredQuestions(state, action) {
      state.answeredQuestions = action.payload;
    },
    setInfoContent(state, action) {
      state.infoContent = action.payload;
    },
    setShowMenu(state, action) {
      state.showMenu = action.payload;
    },
    setShowSubMenu(state, action) {
      state.showSubMenu = action.payload;
    },
    setMenuTitle(state, action) {
      state.menuTitle = action.payload;
    },
  },
});

export const {
  setInnerStepper,
  setProfileStepper,
  setLoading,
  setStepperStatus,
  setTotalQuestions,
  setAnsweredQuestions,
  setInfoContent,
  setShowMenu,
  setShowSubMenu,
  setMenuTitle,
} = commonSlice.actions;
export default commonSlice.reducer;
